module.exports = __webpack_public_path__ + "static/media/ezugi.201d77c2.webp";